// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b084e71e","396":"8ce6a8b8","453":"733f28f0","455":"f5283dde","611":"942a7b3d","924":"1892a757","927":"138068f0","977":"e110096d"}[chunkId] + ".chunk.js";
};